import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectServiceService {

  constructor(private router: Router) { }

  checkDateAndRedirect(): void {
    const targetDate = new Date(2024, 10, 27, 8, 30); //10 is November
    const currentDate = new Date();
    if (currentDate >= targetDate && this.router.url !== '/announce') {
      this.router.navigate(['/announce']);
    }
  }
}
